/**
 * A2UI Image Component
 * Displays images with optional sizing and fit options
 */

import React from 'react';

const fitMap = {
  'contain': 'contain',
  'cover': 'cover',
  'fill': 'fill',
  'none': 'none',
  'scale-down': 'scale-down',
};

const A2UIImage = ({ 
  url,
  alt,
  width,
  height,
  fit = 'cover',
  borderRadius = 0,
  style,
  resolveValue,
  surfaceId
}) => {
  const resolvedUrl = resolveValue ? resolveValue(url, surfaceId) : url?.literalString || '';
  const resolvedAlt = resolveValue ? resolveValue(alt, surfaceId) : alt?.literalString || 'Image';
  
  const imageStyle = {
    width: width ? `${width}px` : '100%',
    height: height ? `${height}px` : 'auto',
    objectFit: fitMap[fit] || 'cover',
    borderRadius: `${borderRadius}px`,
    ...style
  };

  if (!resolvedUrl) {
    return (
      <div 
        className="a2ui-image-placeholder"
        style={{
          ...imageStyle,
          backgroundColor: 'var(--secondary-bg, #e9ecef)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--text-secondary, #6c757d)'
        }}
      >
        No Image
      </div>
    );
  }

  return (
    <img 
      className="a2ui-image"
      src={resolvedUrl}
      alt={resolvedAlt}
      style={imageStyle}
      loading="lazy"
    />
  );
};

export default A2UIImage;
